// frontend/src/utils/etaFormatters.js
// Formatting utilities for ETA Display component

import { formatDistanceMeters } from './distanceUtils';
import { isSameDayInTimeZone, parseBackendUtcInstant } from './dateTimeFormatter';

/**
 * Format time string for local display
 * Handles MySQL/websocket format and ISO format
 * Shows date + time if not today, otherwise just time
 */
export const formatTimeLocal = (timeString, formatTime, formatDateTime, t, timeZone = null) => {
    if (!timeString) return '--:--';
    if (!timeZone) return '--:--';

    try {
        const arrivalDate = parseBackendUtcInstant(timeString);
        if (!arrivalDate || Number.isNaN(arrivalDate.getTime())) return '--:--';

        const now = new Date();

        if (isSameDayInTimeZone(arrivalDate, now, timeZone)) {
            return formatTime(arrivalDate, null, timeZone);
        } else {
            return formatDateTime(arrivalDate, null, null, timeZone);
        }
    } catch (e) {
        console.error("Error formatting arrival time:", timeString, e);
        return t('invalidTime');
    }
};

/**
 * Format distance in appropriate units (metric/imperial)
 */
export const formatDistance = (meters, distanceUnit, t) => {
    return formatDistanceMeters(meters, distanceUnit, t, { compact: false });
};

/**
 * Format duration in human-readable format
 */
export const formatDuration = (minutes, t) => {
    if (minutes === 0 || minutes === null || typeof minutes === 'undefined' || isNaN(minutes)) return '--';

    const totalMinutes = Math.round(parseFloat(minutes));

    if (totalMinutes === 0) return '--';

    if (totalMinutes < 60) {
        return `${totalMinutes} ${t('min')}`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    if (hours < 24) {
        if (remainingMinutes === 0) {
            return `${hours} ${t('hr')}`;
        }
        return `${hours} ${t('hr')} ${remainingMinutes} ${t('min')}`;
    }

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;

    let result = `${days} ${days > 1 ? t('days') : t('day')}`;

    if (remainingHours > 0) {
        result += ` ${remainingHours} ${t('hr')}`;
    }

    if (remainingMinutes > 0) {
        result += ` ${remainingMinutes} ${t('min')}`;
    }

    return result;
};
